import { Injectable } from '@angular/core';
import { IStorageService } from '../interfaces/storage.abstract.service';

@Injectable()
export class StorageServiceMock implements IStorageService {
    private storage: Map<string, string>;

    constructor() {
        this.storage = new Map<string, string>();
    }
    getItem(key: string): string | null {
        return this.storage.get(key);
    }

    setItem(key: string, data: string) {
        this.storage.set(key, data);
    }
    clear(): void {
        this.storage.clear();
    }

    removeItem(key: string) {
        this.storage.delete(key);
    }

    hasItem(key: string): boolean {
        return this.storage.has(key);
    }
}
